import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9f93b43c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=9f93b43c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f93b43c",
  null
  
)

export default component.exports